import React from "react";
import {css, Theme} from "@emotion/react";

import {prettyScroll} from "@pg-design/helpers-css";
import {GalleryPicturesGrid} from "@pg-mono/gallery";
import {useUserDevice} from "@pg-mono/user-device";

import {getPropertyPlanImages} from "../../../property/helpers/get_property_plan_images";
import {PropertyListPlanImage} from "../../../property_list/PropertyListPlanImage";
import {getPropertyPlanModalTitle} from "../../utils/get_property_plan_modal_title";

interface IProps {
    property: {
        area: number;
        id: number;
        number: string;
        offer: {
            address: string;
            name: string;
            type: number;
        };
        plan: string | null;
        plan_image_pages: {
            image: {
                p_img_1500: string;
                p_img_980: string;
                p_img_560: string;
            };
            page: number;
        }[];
        external_plan_url: string | null;
        rooms: number;
    };
}

export const PropertyPlanModalContent = ({property}: IProps) => {
    const {isMobile} = useUserDevice();

    const onPropertyPlanClick = () => {
        if (property.plan) {
            window.open(property.plan, "_blank");
        }
    };

    const title = getPropertyPlanModalTitle(property);

    return (
        <div css={propertyPlanModalContent}>
            {property.plan_image_pages.length <= 1 ? (
                <PropertyListPlanImage property={property} offerName={property.offer.name} />
            ) : (
                <div css={propertyPlanGallery}>
                    <GalleryPicturesGrid
                        getImageAlt={(index) => `rzut ${index + 1} w nieruchomości ${property.number} z inwestycji ${property.offer.name}`}
                        images={getPropertyPlanImages(property.plan_image_pages)}
                        onImageClick={onPropertyPlanClick}
                    />
                </div>
            )}
            {isMobile && <span css={titleStyle}>{title}</span>}
        </div>
    );
};

const propertyPlanModalContent = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 0 0 8rem 0;
    overflow: hidden;

    @media (min-width: ${theme.breakpoints.md}) {
        padding: 0 3rem 2rem 3rem;
    }
`;

const propertyPlanGallery = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.md}) {
        ${prettyScroll("#686975", "#838595")};
    }
`;

const titleStyle = css`
    padding: 2rem;
    font-size: 1.8rem;
    font-weight: 500;
    line-height: 2.52rem;
    color: #fff;
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {prettyScroll} from "@pg-design/helpers-css";
import {GalleryPicturesGrid} from "@pg-mono/gallery";
import {useUserDevice} from "@pg-mono/user-device";

import {getPropertyPlanImages} from "../../../property/helpers/get_property_plan_images";
import {PropertyListPlanImage} from "../../../property_list/PropertyListPlanImage";
import {getPropertyPlanModalTitle} from "../../utils/get_property_plan_modal_title";

interface IProps {
    property: {
        area: number;
        id: number;
        number: string;
        offer: {
            address: string;
            name: string;
            type: number;
        };
        plan: string | null;
        plan_image_pages: {
            image: {
                p_img_1500: string;
                p_img_980: string;
                p_img_560: string;
            };
            page: number;
        }[];
        external_plan_url: string | null;
        rooms: number;
    };
}

export const PropertyPlanModalContent = ({property}: IProps) => {
    const {isMobile} = useUserDevice();

    const onPropertyPlanClick = () => {
        if (property.plan) {
            window.open(property.plan, "_blank");
        }
    };

    const title = getPropertyPlanModalTitle(property);

    return (
        <div css={propertyPlanModalContent}>
            {property.plan_image_pages.length <= 1 ? (
                <PropertyListPlanImage property={property} offerName={property.offer.name} />
            ) : (
                <div css={propertyPlanGallery}>
                    <GalleryPicturesGrid
                        getImageAlt={(index) => `rzut ${index + 1} w nieruchomości ${property.number} z inwestycji ${property.offer.name}`}
                        images={getPropertyPlanImages(property.plan_image_pages)}
                        onImageClick={onPropertyPlanClick}
                    />
                </div>
            )}
            {isMobile && <span css={titleStyle}>{title}</span>}
        </div>
    );
};

const propertyPlanModalContent = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 0 0 8rem 0;
    overflow: hidden;

    @media (min-width: ${theme.breakpoints.md}) {
        padding: 0 3rem 2rem 3rem;
    }
`;

const propertyPlanGallery = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.md}) {
        ${prettyScroll("#686975", "#838595")};
    }
`;

const titleStyle = css`
    padding: 2rem;
    font-size: 1.8rem;
    font-weight: 500;
    line-height: 2.52rem;
    color: #fff;
`;
